import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';

const Response200IO = t.interface({
    automaticWithdrawalEnabled: t.boolean,
});

type AutomaticWithdrawalEnabledType = {
    automaticWithdrawalEnabled: boolean;
};

const isResponse = createGuard(Response200IO);

const decode = (status: number, data: ResponseType): AutomaticWithdrawalEnabledType => {
    if (status === 200 && data.type === 'json') {
        if (isResponse(data.json)) {
            return data.json;
        }
        throw Error('Response decoding error /automatic-withdrawal/automaticWithdrawalEnabled -> get -> 200');
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export const getAutomaticWithdrawal = {
    browser: {
        params: (): ParamsFetchType<void> => {
            return {
                type: MethodType.GET,
                url: '/api-web/automatic-withdrawal/automaticWithdrawalEnabled',
            };
        },
        decode: decode,
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/automatic-withdrawal/automaticWithdrawalEnabled',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<void>): Promise<GenerateUrlApiType> => {
        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                },
            };
        }

        const finalUrl = `${params.API_URL}/banking-configs/${params.API_UNIVERSE}`;

        return {
            url: finalUrl,
            passToBackend: true,
            method: MethodType.GET,
        };
    },
};
